import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, CheckCircle, Shield, Smartphone, XCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Progress } from '../ui/progress';

const SecurityStatsCards = ({ stats, twoFactorRate }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center space-x-2">
            <Users className="h-4 w-4 text-blue-600" />
            <div>
              <p className="text-xs font-medium text-muted-foreground">{t('security.stats.totalUsers')}</p>
              <p className="text-2xl font-bold">{stats.totalUsers}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center space-x-2">
            <CheckCircle className="h-4 w-4 text-green-600" />
            <div>
              <p className="text-xs font-medium text-muted-foreground">{t('security.stats.active')}</p>
              <p className="text-2xl font-bold text-green-600">{stats.activeUsers}</p>
              <Progress value={(stats.activeUsers / stats.totalUsers) * 100} className="mt-2 h-1" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center space-x-2">
            <Shield className="h-4 w-4 text-red-600" />
            <div>
              <p className="text-xs font-medium text-muted-foreground">{t('security.stats.administrators')}</p>
              <p className="text-2xl font-bold text-red-600">{stats.adminUsers}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center space-x-2">
            <Smartphone className="h-4 w-4 text-purple-600" />
            <div>
              <p className="text-xs font-medium text-muted-foreground">{t('security.stats.twoFAEnabled')}</p>
              <p className="text-2xl font-bold text-purple-600">{stats.twoFactorEnabled}</p>
              <div className="mt-2">
                <Progress value={twoFactorRate} className="h-1" />
                <p className="text-xs text-muted-foreground mt-1">{twoFactorRate.toFixed(0)}%</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center space-x-2">
            <XCircle className="h-4 w-4 text-orange-600" />
            <div>
              <p className="text-xs font-medium text-muted-foreground">{t('security.stats.suspended')}</p>
              <p className="text-2xl font-bold text-orange-600">{stats.suspendedUsers}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SecurityStatsCards;
